export const HeroSection = {
  minHeight: '100vh',
};

export const Swiper = {};

export const Slide = {};

export const Overlay = {
  color: '#fff',
};
